export default {
  industries: [],
  industry: undefined,
};
